import sa from 'sa-sdk-javascript'

export default function install (Vue, options = {}) {
  if (install.installed) return
  const h5version = '1.4.0603'
  install.installed = true
  sa.init(options)

  sa.quick('autoTrack')

  Object.defineProperty(Vue.prototype, '$sa', {
    get: () => sa
  })

  sa.click = function (base, data = null) {
    const req = {
      h5_version: h5version,
      ...base,
      ...data
    }
    console.log('NativeAppClick--', req)
    return sa.track('NativeAppClick', req)
  }

  sa.pageview = function (page, data = {}, type = 'AppPageView') {
    let t = {}
    if (typeof page === 'string') {
      t.title = page
    } else {
      t = page
    }
    const req = {
      ...t,
      h5_version: h5version,
      ...data
    }
    console.log(`${type}--`, req)
    sa.track(type, req)
  }

  sa.h5pageview = function (page, data = {}) {
    sa.pageview(page, data, 'H5PageView')
  }
  sa.h5click = function (arg) {
    console.log('H5Click--', arg)
    sa.track('H5Click', arg)
  }
  sa.h5Show = function (arg) {
    console.log('H5Show--', arg)
    sa.track('H5Show', arg)
  }
  sa.LOGIN = function (user) {
    console.log('sa.login', user)
    if (user) {
      return sa.login(user)
    } else {
      return sa.login()
    }
  }
}



// WEBPACK FOOTER //
// ./src/apis/sa-api/install.js